import React from 'react';
import { Card, Progress } from 'antd';
import { withTranslation } from 'react-i18next';

class RamInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <Card
        title={<span style={{ marginLeft: '45%' }}>{t('label_RAMUsage')}</span>}
        bordered={true}
      >
        <Progress
          percent={
            ((parseFloat(this.props.totalRam) -
              parseFloat(this.props.availableRam)) /
              parseFloat(this.props.totalRam)) *
            100
          }
          showInfo={false}
        />
        <br />
        <b>
          <span style={{ marginLeft: '42%' }}>
            {t('ram_infoTxt', {
              used:
                Math.round(
                  (parseFloat(this.props.totalRam) -
                    parseFloat(this.props.availableRam)) *
                    100,
                ) / 100,
              total: this.props.totalRam,
            })}
          </span>
        </b>
      </Card>
    );
  }
}

export default withTranslation()(RamInformationCard);
